import common from './locales/en/common.json';
import hospital from './locales/en/hospital.json';
import bpjs from './locales/en/bpjs.json';
import bpjsFields from './locales/en/bpjsFields.json';

export const englishResources = { common, hospital, bpjs, bpjsFields };
export type UiNamespace = keyof typeof englishResources;

declare module 'i18next' {
    interface CustomTypeOptions {
        defaultNS: 'common';
        resources: typeof englishResources;
        enableSelector: true;
        strictKeyChecks: true;
        returnNull: false;
    }
}
